import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../pages/login/service/auth.service';

@Component({
  selector: 'app-callback',
  standalone: true,
  template: '<p>Procesando inicio de sesión...</p>',
})
export class CallbackComponent implements OnInit {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit() {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get('code');
      const state = urlParams.get('state');
      const error = urlParams.get('error');
      const errorDescription = urlParams.get('error_description');

      if (error) {
        console.error('Error en el flujo OAuth:', error, errorDescription);
        this.router.navigate(['/login'], { queryParams: { error: true, error_description: errorDescription } });
        return;
      }

      if (code && state) {
        console.log('Procesando callback con code:', code, 'y state:', state);
        this.authService.handleOAuthCallback(code, state).subscribe({
          next: (success: boolean) => {
            if (success) {
              console.log('Callback procesado con éxito:', success);
              const userRole = this.authService.getUserRole();
              console.log('Rol del usuario:', userRole);
              if (userRole === 'ADMINISTRATOR') {
                this.router.navigate(['/file-upload']);
              } else if (userRole === 'CISO GLOBAL' || userRole === 'CISO LOCAL') {
                this.router.navigate(['/dashboard']);
              } else {
                this.router.navigate(['/']);
              }
            } else {
              this.router.navigate(['/mfa']);
            }
          },
          error: (err: any) => {
            console.error('Error al procesar el callback:', err);
            this.router.navigate(['/login'], { queryParams: { error: true, error_description: err.message } });
          },
        });
      } else {
        throw new Error('Código de autorización o estado no encontrado en la URL');
      }
    } catch (error) {
      console.error('Error al procesar el callback:', error);
      this.router.navigate(['/login'], { queryParams: { error: true } });
    }
  }
}
